import { Link, LinkProps } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import { ClipText } from './ClipText';
import { getDisplayName } from 'types';
import { BoardProject } from 'api/bindings/BoardProject';
import { BoardProjectResponse } from 'api/bindings/BoardProjectResponse';
import { BoardProjectSearchRecord } from 'api/bindings/BoardProjectSearchRecord';
import { User } from 'api/bindings/User';
import { UserResponse } from 'api/bindings/UserResponse';
import { Afe } from 'api/bindings/Afe';
import { AfeResponse } from 'api/bindings/AfeResponse';
import { AfeSearchRecord } from 'api/bindings/AfeSearchRecord';
import { PurchaseOrder } from 'api/bindings/PurchaseOrder';
import { PurchaseOrderResponse } from 'api/bindings/PurchaseOrderResponse';
import { PurchaseOrderSearchRecord } from 'api/bindings/PurchaseOrderSearchRecord';
import { WorkOrder } from 'api/bindings/WorkOrder';
import { WorkOrderResponse } from 'api/bindings/WorkOrderResponse';
import { WorkOrderSearchRecord } from 'api/bindings/WorkOrderSearchRecord';
import { Invoice } from 'api/bindings/Invoice';
import { InvoiceResponse } from 'api/bindings/InvoiceResponse';
import { InvoiceSearchRecord } from 'api/bindings/InvoiceSearchRecord';
import { AfeInvoice } from 'api/bindings/AfeInvoice';
import { Vendor } from 'api/bindings/Vendor';
import { VendorResponse } from 'api/bindings/VendorResponse';
import { CommitmentType } from 'api';

const LinkPrefix = '/app';

export interface AppLinkProps {}

export const AppLink = (
  props: PropsWithChildren<AppLinkProps> & LinkProps & NavLinkProps
) => {
  const { children, to } = props;
  return <NavLink to={to}>{() => <Link>{children}</Link>}</NavLink>;
};

export interface UserLinkProps {
  u: User | UserResponse | undefined;
}
export const UserLink = (props: UserLinkProps) => (
  <AppLink to={`${LinkPrefix}/users/${props.u?.id}/details`}>
    <ClipText text={getDisplayName(props.u)} />
  </AppLink>
);
export interface BoardProjectLinkProps {
  bp:
    | BoardProject
    | BoardProjectResponse
    | BoardProjectSearchRecord
    | undefined;
}
export const BoardProjectLink = (props: BoardProjectLinkProps) => (
  <AppLink to={`${LinkPrefix}/board-projects/${props.bp?.id}/details`}>
    <ClipText text={props.bp?.name}></ClipText>
  </AppLink>
);
export interface AfeLinkProps {
  afe: Afe | AfeResponse | AfeSearchRecord | undefined;
}
export const AfeLink = (props: AfeLinkProps) => (
  <AppLink to={`${LinkPrefix}/afes/${props.afe?.id}/details`}>
    <ClipText text={props.afe?.name} />
  </AppLink>
);
export interface PurchaseOrderLinkProps {
  po:
    | PurchaseOrder
    | PurchaseOrderResponse
    | PurchaseOrderSearchRecord
    | undefined;
}
export const PurchaseOrderLink = (props: PurchaseOrderLinkProps) => (
  <AppLink to={`${LinkPrefix}/purchase-orders/${props.po?.id}/details`}>
    <ClipText text={props.po?.name} />
  </AppLink>
);

export interface WorkOrderLinkProps {
  // wo: WorkOrderTbl | WorkOrderView | WorkOrderSearchRecordView | undefined;
  wo: WorkOrder | WorkOrderResponse | WorkOrderSearchRecord | undefined;
}

export const WorkOrderLink = (props: WorkOrderLinkProps) => (
  <AppLink to={`${LinkPrefix}/work-orders/${props.wo?.id}/details`}>
    <ClipText text={props.wo?.name} />
  </AppLink>
);

export interface InvoiceLinkProps {
  i: AfeInvoice | Invoice | InvoiceResponse | InvoiceSearchRecord | undefined;
}

export const InvoiceLink = (props: InvoiceLinkProps) => {
  // TODO: HACK
  if (props.i && 'id' in props.i) {
    return (
      <AppLink to={`${LinkPrefix}/invoices/${props.i.id}/details`}>
        <ClipText text={props.i?.name} />
      </AppLink>
    );
  } else {
    return <></>;
  }
};

export interface VendorLinkProps {
  v: Vendor | VendorResponse | undefined;
}
export const VendorLink = (props: VendorLinkProps) => (
  <AppLink to={`${LinkPrefix}/vendors/${props.v?.id}/details`}>
    <ClipText text={props.v?.name} />
  </AppLink>
);

export interface CommitmentLinkProps {
  type: CommitmentType;
  c:
    | PurchaseOrder
    | PurchaseOrderResponse
    | PurchaseOrderSearchRecord
    | WorkOrder
    | WorkOrderResponse
    | WorkOrderSearchRecord
    | undefined;
}

export const CommitmentLink = (props: CommitmentLinkProps) => {
  const { type, c } = props;
  switch (type) {
    case CommitmentType.PurchaseOrder:
      return (
        <PurchaseOrderLink
          po={
            c as
              | PurchaseOrder
              | PurchaseOrderSearchRecord
              | PurchaseOrderResponse
              | undefined
          }
        />
      );
    case CommitmentType.WorkOrder:
      return (
        <WorkOrderLink
          wo={
            c as
              | WorkOrder
              | WorkOrderSearchRecord
              | WorkOrderResponse
              | undefined
          }
        />
      );
    default:
      return <></>;
  }
};
